import { withViewer } from '../../../external/common/hoc/with-viewer';
import AppRoot from '../../../external/post-page/containers/app-root';

export default withViewer(AppRoot);
